
import './InnerPopularDestination2filter.css';

export const InnerPopularDestination2filter = () => {
   
    return (

        <>
            <div className='innerPopularDestination2filtermainDiv'>
                <div className='innerPopularDestination2filtersearchDiv'>
                    <div className='innerPopularDestination2filtersearchText'>Country</div>
                    <div className='innerPopularDestination2filtersearchBox'>
                        Search
                    </div>
                </div>
                <div className='innerPopularDestination2filterBudgetDiv'>
                    <div className='innerPopularDestination2filtersearchText'>Budget</div>
                    <div className='innerPopularDestination2filtersearchBox'>
                        Low to High
                    </div>
                </div>
            </div>
        </>

    );
}

